import { TextInput } from '@bambi/component-library/src/components/inputs/TextInput/TextInput';
import { useState } from 'react';

import { MAX_OTHER_REJECT_REASON_LENGTH } from 'src/features/trip/management/cancel/otherReason';

// Keeps keystrokes in local state and commits on blur: dispatching per
// keystroke re-renders every subscriber of dispatcher.modals (the whole
// reject modal plus dispatch-page components behind it), which lags typing.
// Blur fires before the Reject button's click handler reads the store, so
// the committed value is always current at confirm time.
export function OtherReasonDraftInput({
  initialText,
  onCommit,
  ariaLabel,
  dataTestId,
}: {
  initialText: string;
  onCommit: (text: string) => void;
  ariaLabel: string;
  dataTestId: string;
}) {
  const [draft, setDraft] = useState(initialText);

  return (
    <TextInput
      placeholder="Reason (optional)"
      value={draft}
      maxLength={MAX_OTHER_REJECT_REASON_LENGTH}
      aria-label={ariaLabel}
      data-testid={dataTestId}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={() => onCommit(draft)}
    />
  );
}
